var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.footerShow)?_c('v-footer',{attrs:{"app":"","padless":"","inset":""}},[_c('v-card',{staticClass:"secondary text-center",attrs:{"flat":"","tile":"","width":"100%"}},[_c('v-card-text',{staticClass:"white--text"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Farina Vending Control Panel")])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }